export const DEFAULT_RETAILER_MATCH_SOURCE_COLUMN = "retailer_name";
export const DEFAULT_RETAILER_MATCH_PRIORITY = 999;

export const MATCH_PATTERN_ALREADY_EXISTS_MESSAGE =
  "This match pattern already exists for the selected source column.";

export const SOURCE_COLUMN_INVALID_MESSAGE = "Source column is invalid.";

export const RAW_RETAILER_NAME_ALREADY_EXISTS_MESSAGE =
  "This raw retailer name is already associated.";

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return "";
}

export function resolveDefaultRetailerMatchSourceColumn(
  sourceColumns: readonly string[],
): string {
  if (sourceColumns.includes(DEFAULT_RETAILER_MATCH_SOURCE_COLUMN)) {
    return DEFAULT_RETAILER_MATCH_SOURCE_COLUMN;
  }
  return sourceColumns[0] ?? "";
}

export function isInvalidSourceColumnError(error: unknown): boolean {
  return getErrorMessage(error)
    .toLowerCase()
    .includes("source_column is invalid");
}

export function isMatchPatternDuplicateError(error: unknown): boolean {
  const normalized = getErrorMessage(error).toLowerCase();
  return (
    normalized.includes("match pattern") ||
    normalized.includes("source column") ||
    normalized.includes("already exists")
  );
}

export function isRawRetailerNameDuplicateError(error: unknown): boolean {
  const normalized = getErrorMessage(error).toLowerCase();
  return (
    normalized.includes("raw retailer name") ||
    normalized.includes("already associated") ||
    normalized.includes("already exists")
  );
}
